import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { xssFilter } from "../../common/utils/xssFilter";

function ArticleOfferTitle(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }
    const dataEntity = EntityBuilder.of(props.data, { inplace: true });
    const pictoEntity = dataEntity.getChild("picto");
    const pictoEntitySrc = pictoEntity.getProperty("src");
    const pictoEntityAlt = pictoEntity.getProperty("alt");
    const headline = dataEntity.getChild("headline").getValue();
    const subtitle = dataEntity.getChild("subtitle").getValue();
    const badge = dataEntity.getChild("badge").getValue();
    let titleStyle = {};
    if (!pictoEntitySrc) {
        titleStyle = {
            width: "100%"
        };
    }
    return (
        <div className="un-article-content-panel un-article-content-panel-sm un-article-content-panel-offer">
            <div className="un-article-main-accent">
                {badge && (
                    <span className=" tq-badge ">
                        <span className="tq-text-node">{badge}</span>
                    </span>
                )}
                <div className="un-article-main-accent-content">
                    {pictoEntitySrc && (
                        <div className="un-article-main-accent-icon">
                            <img src={pictoEntitySrc} alt={pictoEntityAlt} />
                        </div>
                    )}
                    {headline && (
                        <p className="tq-panel-title tq-title-background">
                            <span
                                className="tq-text-node"
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(headline)
                                }}
                                data-hyperlinks-container={true}
                            />
                        </p>
                    )}
                    <div className="tq-text-content" style={titleStyle}>
                        <h1
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(data.value)
                            }}
                            data-hyperlinks-container={true}
                        />
                        {subtitle && (
                            <h2
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(subtitle)
                                }}
                                data-hyperlinks-container={true}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default webui.connectComponent()(ArticleOfferTitle);
